import api from "./api";

const analyticsService = {
  getSummary: (params) => api.get("/analytics/summary", { params }),
};

export default analyticsService;
